import { useMemo } from "react";

export function useBoardPermissions(board, error) {
  return useMemo(() => {
    const workflowId = board?.workflow_id ?? null;
    const ownerId = board?.owner_user_id ?? null;
    const isPermissionDenied =
      error?.response?.data?.message === "Permision Denied";
    const errorMessage = error
      ? isPermissionDenied
        ? "You are not authorized to view this board."
        : "The board you are looking for does not exist or has been deleted."
      : null;

    return {
      ownerId,
      workflowId,
      hasWorkflow: Boolean(workflowId),
      errorMessage,
      isPermissionDenied,
    };
  }, [board, error]);
}
